<div
  class="bg-white rounded p-6 flex items-end justify-between"
  style="box-shadow: 0px 4px 24px rgba(27, 28, 77, 0.16)"
>
  <div class="flex flex-col justify-between h-full">
    @if (logo$() | async; as logo) {
      <img
        [src]="'data:image/svg+xml;base64,' + logo"
        [alt]="versichererName() + ' logo'"
        class="h-12 max-w-[160px] w-auto mb-4 object-contain object-left"
      />
    }
    <div class="font-bold text-base text-cp-primary-100">{{ tarifName() }}</div>
  </div>
  <div class="text-right">
    <div class="text-[13px] text-cp-primary-100">{{ results.beitragCaption() }}</div>
    @if (price(); as price) {
      <div
        class="font-grotesk-h6"
        [class.text-cp-primary-100]="!price.provisional"
        [class.text-cp-primary-60]="price.provisional"
      >
        {{ price.betrag | currency }}
      </div>
      @if (price.provisional) {
        <div class="text-[13px] text-cp-primary-60">vorläufig</div>
      }
    } @else if (state() === 'loading') {
      <div class="ghost h-7 w-24 ml-auto" aria-busy="true"></div>
    } @else {
      <div class="font-grotesk-h6 text-cp-primary-60">–</div>
    }
  </div>
</div>
